// src/pages/WaitingRoom.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../api";
import "./WaitingRoom.css";

export default function WaitingRoom() {
  const { sessionId, role } = useParams();
  const navigate = useNavigate();
  const [hasMarkedReady, setHasMarkedReady] = useState(false);

  const fullText =
    "Waiting for both of you to complete the process.\n\n" +
    "You can press ready, and maybe wait for your partner, thank you .";

  const [typed, setTyped] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (charIndex < fullText.length) {
      const t = setTimeout(() => {
        setTyped(prev => prev + fullText[charIndex]);
        setCharIndex(i => i + 1);
      }, 32);

      return () => clearTimeout(t);
    }
  }, [charIndex, fullText]);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${API_BASE}/check_ready/${sessionId}`);
        const data = await res.json();

        if (data.both_ready) {
          clearInterval(interval);
          setTimeout(() => {
            navigate(`/results/${sessionId}/${role}`);
          }, 1500);
        }
      } catch {
        console.error("check_ready failed");
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [sessionId, role, navigate]);

  async function markReady() {
    try {
      await fetch(`${API_BASE}/ready`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          role
        })
      });

      setHasMarkedReady(true);
    } catch {
      alert("Failed to mark ready");
    }
  }

  return (
    <div className="waiting-container fade-in">
      <div className="waiting-card card">
        <p
          style={{
            whiteSpace: "pre-wrap",
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 16,
            lineHeight: 1.9,
            letterSpacing: "0.04em",
            color: "#E8E2D6",
            marginBottom: 32
          }}
        >
          {typed}
        </p>

        {!hasMarkedReady && (
          <button
            className="btn btn-primary"
            onClick={markReady}
            style={{ marginTop: 30 }}
          >
            I am ready
          </button>
        )}

        {hasMarkedReady && (
          <p
            className="waiting-pulse"
            style={{
              marginTop: 40,
              fontFamily: "Cormorant Garamond, serif",
              fontSize: 16,
              lineHeight: 1.8,
              letterSpacing: "0.04em",
              textAlign: "center",
              color: "#E8E2D6",
              animation: "pulseText 2.2s ease-in-out infinite"
            }}
          >
            Waiting for your partner…
          </p>
        )}
      </div>
    </div>
  );
} 
